import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import SomethingWentWrongImage from "./assets/something-went-wrong.png";
import ThemeProvider from "@mui/material/styles/ThemeProvider";

const message = `Illustration of a girl sitting on a beanbag 
chair using her cell phone next to a potted plant and a lamp`;

const DownTime = (props) => (
  <ThemeProvider theme={props.theme}>
    <Container
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Grid
        container
        gap={12}
        direction="row"
        justifyContent="center"
        alignItems="center"
        alignSelf="center"
      >
        <Grid item xs={4.5}>
          <Container maxWidth="sm">
            <Typography
              variant="h1"
              sx={{ color: "primary.dark", fontSize: 60 }}
            >
              Something went wrong!
            </Typography>
            <Typography variant="body1" sx={{ marginTop: "24px" }}>
              Sorry! It seems something wrong is happening with our systems. We
              should have this fixed soon!
            </Typography>
          </Container>
        </Grid>
        <Grid item xs={5.5}>
          <img src={SomethingWentWrongImage} alt={message} width={627} />
        </Grid>
      </Grid>
    </Container>
  </ThemeProvider>
);

export default DownTime;
